export const defaultData: Country = {
  allowedCurrencies: ['EUR', 'USD', 'MXN'],
  countryCode: 'IE',
  locales: ['en', 'pt', 'es', 'es-MX', 'fr', 'it', 'de'],
  name: '',
};
